import React, { useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";
import { Col, Row, Spinner } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";

import { PatientCard } from "./PatientCard";
import { getPatientList } from "../../../../redux/actions/dbactions/pateints";
import { Header } from "../../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";

export const ProfileListexplore = () => {
  const dispatch = useDispatch();
  const { serviceID } = useParams();

  useEffect(() => {
    dispatch(getPatientList());
  }, [dispatch, serviceID]);
  const { exploreList } = useSelector((state) => state.exploreReducer);

  const { patientsList, isLoading, currentData, bookingData } = useSelector(
    (state) => state.patients
  );

  const exploreService = exploreList?.svc_typ_desc;
  const explorelist = exploreList.usr?.rec || [];

  const patientsLists = patientsList.usr?.svcUserProfile || [];
  const [selectedColor, setSelectedColor] = useState(null);
  const [isDisabled, setIsDisabled] = useState(null);
  const HandleClick = (id) => {
    setSelectedColor(selectedColor === id ? null : id);
    setIsDisabled(isDisabled === id ? null : id);
  };

  return (
    <div>
      <Header
        pageTitle={`Explore > ${exploreService} > ${
          explorelist?.at(0)?.svcf_name
        } > ${currentData?.svc_name} > Patient Lists`}
        icon={<Icon icon="material-symbols:explore-outline" />}
      />

      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap m-0">
          My Patient List
        </h5>
        <div className="w-fit whitespace-nowrap">
          <Link
            to={`/dashboard/explore/add-patient`}
            className=" !text-xs sign_btn"
          >
            + Add A New Patient
          </Link>
        </div>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <Row className="sm:!px-4 m-0">
        {patientsLists.length > 0 ? (
          patientsLists.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <PatientCard
                data={item}
                HandleClick={() => HandleClick(item.svcuser_profile_id)}
                selectedColor={selectedColor}
                isDisabled={isDisabled}
                currentData={currentData}
                bookingData={bookingData}
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Patients found</p>
          </Col>
        )}
      </Row>
      {/* <DeleteModal
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
        handleDelete={handleDelete}
      />
      <AddModal
        show={addmodal}
        onHide={() => setAddmodal(false)}
        setRefresh={setRefresh}
        setAddmodal={setAddmodal}
        serviceid={facilityId}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
        serviceid={facilityId}
      /> */}
    </div>
  );
};
